<template>
  <div class="container">
    <PoiCard v-if="poi && 'id' in poi" :poi="getPoi" imageWidth="1900" />
    <div v-if="poi && 'id' in poi && (isOwner || isValidator)">
      <b-row class="no-gutters">
        <b-col cols="3">
          <b-form-group label="Categories:" class="mt-2 mb-0">
            <treeselect
              v-model="poi.geojson.properties.categories"
              :options="optionsCategories"
              disable-branch-nodes
              multiple
              show-count
            >
              <div slot="value-label" slot-scope="{ node }">
                {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
              </div>
            </treeselect>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="ml-2 mr-2">
          <b-form-group label="Hashtags:" class="mt-2 mb-0">
            <treeselect
              v-model="poi.geojson.properties.hashtags"
              :options="optionsHashtags"
              disable-branch-nodes
              multiple
              show-count
            >
              <div slot="value-label" slot-scope="{ node }">
                {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
              </div>
            </treeselect>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Weather Conditions:" class="mt-2 mb-0">
            <treeselect
              v-model="poi.geojson.properties.weather"
              :options="optionsWeather"
              disable-branch-nodes
              multiple
              show-count
            >
              <div slot="value-label" slot-scope="{ node }">
                {{ node.raw.customLabel ? node.raw.customLabel : node.raw.label }}
              </div>
            </treeselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="mt-2 mb-2 ml-3">
          <b-button @click="onClickSave(poi)" variant="success" size="sm">
            Save
          </b-button>
          <b-button :to="{ name: 'pois-list' }" variant="secondary" size="sm" class="ml-2">
            Cancel
          </b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { db } from '@/main';

import PoiCard from '@/components/PoiCard';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'PoiView',
  components: { PoiCard, Treeselect },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      config: 'config/records',
      poi: 'poi/record',
      user: 'auth/user',
    }),
    getPoi() {
      return this.poi;
    },
    isOwner() {
      return this.user.data.uid === this.poi.created_by;
    },
    isValidator() {
      return this.user.data.profile.roles.includes('validator');
    },
    optionsCategories() {
      return this.config?.optionsCategories ? this.config.optionsCategories : [];
    },
    optionsHashtags() {
      return this.config?.optionsHashtags ? this.config.optionsHashtags : [];
    },
    optionsWeather() {
      return this.config?.optionsWeather ? this.config.optionsWeather : [];
    },
  },
  methods: {
    onClickSave(poi) {
      const payload = {
        collection: 'pois',
        docId: poi.id,
        data: {
          geojson: poi.geojson,
          validated: true,
        },
      };
      this.updateDocument(payload);
    },
    updateDocument(payload) {
      const docRef = db.collection(payload.collection).doc(payload.docId);
      return docRef
        .update(payload.data)
        .then(() => {
          // ToDo: display toast SUCCESS
          console.log('Document successfully updated!');
        })
        .catch(error => {
          // ToDo: display toast FAILURE
          // the document probably doesn't exist.
          console.error('Error updating document: ', error);
        });
    },
  },
  created() {
    const payload = { doc: this.$route.params.id };
    this.$store.dispatch('poi/bindRecords', payload);
  },
  mounted() {
    this.$store.dispatch('config/bindRecords');
  },
};
</script>

<style scoped></style>
